// The Tagesbericht's words: why a report carries no narrative, who made it,
// and a refused run or read.

import { INSIGHT_SCHEDULER } from "@/api/types";
import { t, tOr } from "@/i18n";
import { formatInt } from "@/lib/format";
import { errorDetail, httpStatus } from "@/lib/runtimeChange";

/** How many days before today a report can be made for: the retention of the
 * conversations it reads (session_ttl_days_anonymous). The backend refuses
 * any other day with invalid_day. */
export const REPORT_RETENTION_DAYS = 365;

/** Why a report has no narrative, in words; a kind without words names itself. */
export function failureText(failure: string): string {
  const kind = failure || "unexpected";
  return tOr(`insights.failure.${kind}`, t("insights.failure.other", { kind }));
}

/** Who made a report: the nightly schedule, or an admin by e-mail. */
export function creatorLabel(createdBy: string): string {
  return createdBy === INSIGHT_SCHEDULER ? t("insights.createdBy.scheduler") : createdBy;
}

/** A refused run or read in words; the HTTP error when it names no code. */
export function insightError(err: unknown): string {
  switch (errorDetail(err).error) {
    case "invalid_day":
      return t("insights.error.invalid_day", { days: formatInt(REPORT_RETENTION_DAYS) });
    case "storage_failed":
      return t("insights.error.storage_failed");
    case "not_found":
      return t("insights.error.not_found");
  }
  if (httpStatus(err) === null) return t("insights.error.network");
  return err instanceof Error ? err.message : String(err);
}
